<div
  (scrolled)="onScroll()"
  [infiniteScrollDistance]="2"
  [infiniteScrollThrottle]="10"
  [scrollWindow]="false"
  class="table-wrapper overflow-auto xs:h-[calc(100vh-15rem)] sm:h-[calc(100vh-20rem)]"
  infiniteScroll
>
  <table
    [class.hidden]="weekListLoading && isFirstPage"
    [dataSource]="dataSource"
    mat-table
    matSort
  >
    <!--WEEK-->
    <ng-container
      [sticky]="true"
      matColumnDef="weekNumber"
    >
      <th
        *matHeaderCellDef
        id="weekNumber"
        mat-header-cell
      >
        <div class="th-cell">
          Week
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[10rem] min-w-[10rem] md:w-[10rem] md:min-w-[10rem]"
          mat-cell>
        <div class="td-cell">
          <span (click)="disableLink(eachRow.startDate) ?
           {}:redirectToWeekDetails(eachRow)"
                [class.clickable]="!disableLink(eachRow.startDate)"
          > Week {{ eachRow?.weekNumber }}</span>
        </div>
      </td>
    </ng-container>
    <!--DATE-->
    <ng-container
      matColumnDef="date"
    >
      <th
        *matHeaderCellDef
        id="date"
        mat-header-cell
      >
        <div class="th-cell">
          Date
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[16rem] min-w-[16rem] md:w-[16rem] md:min-w-[16rem]"
          mat-cell>
        <div class="td-cell">
          {{ eachRow?.startDate | date:'MMM dd' }}
          - {{ eachRow?.endDate | date:'MMM dd' }}
        </div>
      </td>
    </ng-container>
    <!--SESSION-->
    <ng-container
      matColumnDef="sessions"
    >
      <th
        *matHeaderCellDef
        id="sessions"
        mat-header-cell

      >
        <div class="th-cell">
          Session
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem] md:w-[15rem] md:min-w-[15rem]"
          mat-cell>
        <div
          *ngFor="let eachSession of eachRow['sessions']"
          class="td-cell session flex flex-col gap-[1rem]"
        >
          <div
            *ngIf="eachSession['sessionNumber']"
            class="session flex flex-row justify-start items-center gap-x-[1rem]"
          >
            <span class="pill-container">
              S{{ eachSession['sessionNumber']| number: '2.0-0' }}
            </span>
            <span class="session-date">
              {{ eachSession['date'] | date: 'MMM dd' }}
            </span>
          </div>
        </div>
      </td>
    </ng-container>
    <!--WEIGHT-->
    <ng-container
      matColumnDef="weight"
    >
      <th
        *matHeaderCellDef
        id="baseWeight"
        mat-header-cell
      >
        <div class="th-cell">
          Weight
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[12rem] min-w-[12rem] md:w-[12rem] md:min-w-[12rem]"
          mat-cell>
        <div class="td-cell flex flex-row justify-start items-center gap-x-[2rem]">
          <app-icon
            *ngIf="eachRow?.weight"
            class="weight-icon"
            svgIcon="weight"
          ></app-icon>
          {{ eachRow?.weight }}
        </div>
      </td>
    </ng-container>
    <!--# OF DAYS-->
    <ng-container
      matColumnDef="numberOfDaysCompleted"
    >
      <th
        *matHeaderCellDef
        id="numberOfDaysCompleted"
        mat-header-cell
      >
        <div class="th-cell">
          Journaling
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[12rem] min-w-[12rem] md:w-[12rem] md:min-w-[12rem]"
          mat-cell>
        <div
          *ngIf="eachRow['noOfDays']"
          class="td-cell">
          {{ eachRow['noOfDays'] }} Days
        </div>
      </td>
    </ng-container>
    <!--RED LIGHTS-->
    <ng-container
      matColumnDef="redLights"
    >
      <th
        *matHeaderCellDef
        id="redLights"
        mat-header-cell
      >
        <div class="th-cell">
          Red Lights
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[14rem] min-w-[14rem] md:w-[14rem] md:min-w-[14rem]"
          mat-cell>
        <div
          *ngIf="(showDetailsForAdult || eachRow['lastSession'] >= 2) &&
          eachRow['rlPoints'] !==
          null;
          else noData"
          class="td-cell flex flex-row justify-start items-center gap-x-[0.5rem]">
          <app-icon
            class="red-light-icon"
            svgIcon="red-light"
          ></app-icon>
          {{ eachRow['rlPoints'] }}
        </div>
        <ng-template #noData>
          <div class="td-cell flex flex-row justify-start items-center gap-x-[0.5rem]">

          </div>
        </ng-template>
      </td>
    </ng-container>
    <!--PHYSICAL ACTIVITY-->
    <ng-container
      matColumnDef="physicalActivity"
    >
      <th
        *matHeaderCellDef
        id="physicalActivity"
        mat-header-cell
      >
        <div class="th-cell">
          Physical Activity
        </div>
      </th>
      <td
        *matCellDef="let eachRow"
        class="w-[18rem] min-w-[18rem] md:w-[18rem] md:min-w-[18rem]"
        mat-cell
      >
        <ng-container *ngIf="eachRow.paDays > 0 || eachRow.paTotalDays > 0">
          <div
            *ngIf="(selectedUserRole === roles.participant || role === roles.participant) && eachRow['paGoalPoints']
          !== null; else checkAdult"
            class="td-cell flex flex-row justify-start items-center gap-x-[1rem]"
          >
            <app-icon svgIcon="physical-activity"/>
            {{ eachRow['paGoalCompletedDays'] + ' day' + (eachRow['paGoalCompletedDays'] !== 1 ? 's' : '') + ' @ ' +
          (eachRow['paGoalPoints'] | number:'1.0':'en-US') + '+' }}
          </div>
          <ng-template #checkAdult>
            <div
              *ngIf="(selectedUserRole === roles.adult || role === roles.adult) && eachRow['paPoints'] !== null"
              class="td-cell flex flex-row justify-start items-center gap-x-[1rem]"
            >
              <app-icon svgIcon="physical-activity"/>
              {{ eachRow['paDays'] + ' day' + (eachRow['paDays'] !== 1 ? 's' : '') }}
            </div>
          </ng-template>
        </ng-container>
      </td>
    </ng-container>
    <!--SCREEN TIME-->
    <ng-container
      matColumnDef="screenTime"
    >
      <th
        *matHeaderCellDef
        id="screenTime"
        mat-header-cell

      >
        <div class="th-cell">
          Screen Time
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem] md:w-[15rem] md:min-w-[15rem]"
          mat-cell>
        <div
          *ngIf="(showDetailsForAdult || eachRow['lastSession'] >= 15) && eachRow['stPoints'] !==
          null;
          else noData"
          class="td-cell flex flex-row justify-start items-center gap-x-[0.5rem]">
          <app-icon
            class="screen-time-icon"
            svgIcon="screen-time"
          ></app-icon>
          {{ eachRow['stPoints'] | hrAndMin }}
        </div>
        <ng-template #noData>
          <div class="td-cell flex flex-row justify-start items-center gap-x-[0.5rem]">

          </div>
        </ng-template>
      </td>
    </ng-container>
    <!--CONTRACT-->
    <ng-container
      matColumnDef="contractId"
    >
      <th
        *matHeaderCellDef
        id="contractStatus"
        mat-header-cell
      >
        <div class="th-cell flex flex-row items-center">
          <span>Goals & Contracts</span>
          <app-icon
            [matTooltip]="goalsContractsTooltipText"
            class="tooltip-icon"
            matTooltipClass="custom-tooltip"
            matTooltipPosition="below"
            svgIcon="info"
          ></app-icon>
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[20rem] min-w-[20rem] md:w-[20rem] md:min-w-[20rem]"
          mat-cell>
        <div
          *ngIf="eachRow['lastSession'] >= 4;
          else noData"
          class="td-cell flex flex-row justify-start items-center gap-x-[1rem]">
          <app-icon
            [svgIcon]="eachRow['signedOn'] ? 'contract-met':'contract-not-met'"
            class="{{eachRow['signedOn'] ?
            'contract-met-icon':'contract-not-met-icon'}} {{ eachRow['createdAt'] ? '' : 'contract-not-saved-icon' }}"
          ></app-icon>
          <span
            (click)="disableLink(eachRow?.startDate) ?
            {}:redirectToContracts(eachRow)"
            [class.clickable]="!disableLink(eachRow?.startDate)"
          >
            Goals & Contract
          </span>
        </div>
        <ng-template #noData>
          <div class="td-cell flex flex-row justify-start items-center gap-x-[1rem]">
          </div>
        </ng-template>
      </td>
    </ng-container>

    <tr *matHeaderRowDef="displayedColumns; sticky: true"
        mat-header-row></tr>
    <tr *matRowDef="let row; columns: displayedColumns;"
        mat-row></tr>

  </table>
  <div *ngIf="weekListLoading"
       [ngClass]="{ 'initial': isFirstPage }"
       class="table-loader w-full flex justify-center items-center">
    <mat-spinner/>
  </div>
  <div
    *ngIf="!weekListLoading && !dataSource.data?.length"
    class="no-data flex flex-col justify-center items-center"
  >
    <div class="text">
      {{ isGroupNotStarted ? "Your group hasn't started yet." : 'No data matching the filter.' }}
    </div>
  </div>
</div>
